import React, { useState, useRef, useEffect } from 'react'

import { SingleSunburst, SunburstContainer } from 'nswidgets/src/components/sunburst/sunburst'

import { ControlBar } from '../control-bar'
import { blockDataService } from '../block-data.service'
import { ChartLoader } from '../chart-loader'
import { reportBlockService } from '../report-block.service'
import { reportDataSetService } from '../../editor/report-data-set.service'
import { reportLayoutService } from '../report-layout.service'
import { Legend } from 'nswidgets/src/common/legend/legend'
import { SplitChartFilterBar } from '../split-chart-filter-bar'
import { useStyles } from './sunburst-block.style'
import { SideBySideChart } from '../side-by-side-chart'
import { SideBySideChartContainer } from '../side-by-side-chart-container'

const DEFAULT_WIDTH = 1024

export const SunburstBlock = function ({
  blockKey,
  dataKey,
  data,
  report,
  strataDefinition,
  sliderDefinition,
  filterDefinition,
  parentControlBar,
  parentBlock,
  parentBlockSelections,
  width = DEFAULT_WIDTH,
  splitChart,
  legendPosition = 'right',
  ...props
}) {
  const rawData = useRef([])
  const classes = useStyles()
  const block = report.layout.blocks.find((block) => block.key === blockKey)

  const [chartData, setChartData] = useState()
  const [selections, setSelections] = useState()
  const [splitChartSelections, setSplitChartSelections] = useState(reportDataSetService.getFilterDefinitionSplitChartSelections(filterDefinition))
  const [types, setTypes] = useState()
  const [propOverrides, setPropOverrides] = useState()

  props = reportLayoutService.applyPropOverrides(props, propOverrides)

  useEffect(updateTypes, [props.types])

  function onDataLoad (data) {
    // Update raw data list
    const dataList = splitChart ? data : [data]
    rawData.current.length = dataList.length
    dataList.forEach((data, i) => {
      rawData.current[i] = data[0].data
    })

    // Update the chart states
    updateChart(selections)

    // Update block's type data
    updateTypes()
  }

  function updateTypes () {
    // Update block's type data
    const currentBlock = report.layout.blocks.find(({ key }) => (blockKey === key))
    dataKey = dataKey || currentBlock.dataKey
    const typesFromMetadata = reportDataSetService.getDataSetLabels(report, dataKey).sunburstTypes
    const typesFromLayout = props && props.types
    const type = reportBlockService.getTheRightConfiguration(typesFromMetadata, typesFromLayout)
    setTypes(type)
  }

  function updateChart (currentSelections) {
    if (!rawData || !rawData.current[0] || (splitChart && !rawData.current[1])) {
      return
    }

    const newChartData = []
    rawData.current.forEach((data) => {
      const filteredData = blockDataService.filterBlockDataByKeyValue(data, sliderDefinition && sliderDefinition.key, currentSelections.slider)
      newChartData.push(filteredData)
    })
    setChartData(newChartData)
  }

  function onControlBarChange (selections, changes) {
    if (changes.props) {
      setPropOverrides(selections.props)
    }

    if (changes.slider) {
      updateChart(selections)
    } else {
      setSelections(selections)
    }
  }

  const sunburstData = {
    types,
    width: splitChart ? width / 1.4 : width,
    legendPosition,
    ...props
  }

  const missingSideBySideChartStyle = {
    width: 480,
    height: 480
  }

  return (
    <div className="report-full-width">
      <ControlBar
        strataDefinition={strataDefinition}
        sliderDefinition={sliderDefinition}
        filterDefinition={filterDefinition}
        parentControlBar={parentControlBar}
        parentBlock={parentBlock}
        parentBlockSelections={parentBlockSelections}
        onChange={onControlBarChange} />
      <div>
        <ChartLoader report={report} blockKey={blockKey} dataKey={dataKey} sliderDefinition={sliderDefinition} selections={selections} splitChart={splitChart} splitChartSelections={splitChartSelections} width={width} onDataLoad={onDataLoad}>
          <SunburstContainer data={chartData && chartData[0]} {...sunburstData}>
            {({ colors }) => (
              <>
                <Legend labels={types ? Object.values(types) : []} colors={colors ? Object.values(colors) : []} position={legendPosition} />
                {splitChart && <SplitChartFilterBar block={block} filterDefinition={filterDefinition} onChange={setSplitChartSelections} className={classes.sideBySideChartFilterBar} />}
                {splitChart && chartData && chartData.length === 2 ? (
                  <>
                    <SideBySideChartContainer>
                      <SideBySideChart data={chartData && chartData[0] && chartData[0].length} missingChartStyles={missingSideBySideChartStyle}>
                        <SingleSunburst data={chartData[0]} {...sunburstData} colors={colors} isCompressed />
                      </SideBySideChart>
                      <SideBySideChart data={chartData && chartData[1] && chartData[1].length} missingChartStyles={missingSideBySideChartStyle}>
                        <SingleSunburst data={chartData[1]} {...sunburstData} colors={colors} isCompressed />
                      </SideBySideChart>
                    </SideBySideChartContainer>
                  </>
                ) : (
                  <SingleSunburst data={chartData[0]} {...sunburstData} colors={colors} />
                )}
              </>
            )}
          </SunburstContainer>
        </ChartLoader>
      </div>
    </div>
  )
}
